<template>
    <div class="step">
        <div class="wrap-title">
            <div class="title"><span>Шаг 1</span> Прикрепите ваши анализы</div>
            <div class="title-2" v-if="existAttachments()">Ваши анализы</div>
        </div>
        <div class="first-step">
            <div>
                <Drop @drop="drop" 
                    v-bind:class="[dragging ? 'drag-drop-wrapp drag-active' : 'drag-drop-wrapp']" 
                    @dragover="dragging=true">Перетащите сюда файл</Drop>
                <p>или выберите вручную</p>
                <label for="addFile">Добавить файл</label>
                <input type="file" ref="file" id="addFile" @change="addFileInput" multiple>
            </div>
            <transition name="fade">
                <div class="load-files" v-if="existAttachments()">
                    <div class="file-block">
                        <div class="files" v-for="(attachment, index) in attachments" :key="attachment.id">
                            <div class="file" 
                                v-bind:class="{ loading: attachment.status == 'loading', 
                                                errorfile : attachment.status == 'error'}">
                                <svg>
                                    <circle class="bg" r="11" cx="20" cy="20" stroke="#CED2D6"></circle>
                                    <circle class="loader" r="11" cx="20" cy="20" stroke="#00AABE"></circle>
                                </svg>
                                <button class="delete" @click="removeFile($event, index)"></button><span>{{ attachment.name }}</span>
                            </div>
                        </div>
                        <div class="error" v-if="error.exist" >{{ error.message }}</div>
                    </div>
                    <button class="done" @click="complete()" :disabled="lockButton">Готово</button>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import { Drop } from 'vue-drag-drop';
    import _ from 'lodash';

    import { bus } from '../../main'

    import './step1.scss'

    export default {
        name: 'Step1',
        props: ['attachments'],
        data() {
            return {
                dragging: false,
                error:{
                    exist: false,
                    message: '',
                },
                addedFirstAttachment: false
            }
        },
        methods: {
            setError: function (message) {
                this.error.exist = true;
                this.error.message = message;
            },
            clearError: function() {
                this.error.exist = false;
                this.error.message = '';
            },
            existAttachments() {
               return this.attachments.length;
            },
            removeFile(event, index) {
                this.$delete(this.attachments, index);
                this.clearError();
            },
            loadFile: function (file) {
                const self = this;

                const formData = new FormData();
                formData.append('file[' + 0 + ']', file);

                const attachmentFile = {
                    name: file.name,
                    status: 'loading',
                };

                self.dragging = false;

                self.attachments.push(attachmentFile);

                let url = process.env.VUE_APP_HOST + '/mobile/load_temporary_attachment_files/';
                fetch(url, {
                    method: 'POST',
                    body: formData
                }).then(function (response) {
                    response.json().then(function (data) {
                    if (data.status === 'OK') {
                            attachmentFile.id = data.attachments[0].id;
                            attachmentFile.status = 'loaded';
                        } else {
                            attachmentFile.status = 'error';
                            self.setError(data.message);
                        }
                    })
                }, () => {
                    attachmentFile.status = 'error';
                    self.setError('Возникла неизвестная ошибка');
                });
            },
            addFileInput: function () {
                const files = this.$refs.file.files;
                for (let i = 0; i < files.length; i++) {
                    this.loadFile(files.item(i));
				}
            },
            drop: function (data, event) {
				const files = event.dataTransfer.files;
                for (let i = 0; i < files.length; i++) {
                    this.loadFile(files.item(i));
				}
            },
            complete: function() {
                bus.$emit('laboratoryLanding.analytics', {action: 'loadAttachments'});

                this.$emit('complete');
            }
        },
        watch: {
            attachments: {
                deep: true,
                handler() {
                    if (!this.addedFirstAttachment) {
                        bus.$emit('laboratoryLanding.analytics', {action: 'loadFirstAttachment'});
                        this.addedFirstAttachment = true;
                    }
                }
            }
        },
        computed: {
            lockButton: function () {
                return _.filter(this.attachments, {status: 'loaded'}).length !== this.attachments.length;
            }
        },
        components: {
            Drop
        },
    }
</script>
